export const MARGIN = { left: 0, right: 3, top: 10 };
